import { useTranslations } from "use-intl";

export function useSigningTranslations() {
  return useTranslations("Signing");
}
